// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import "./blog.css";

// const BlogHome = () => {
//   const [blogs, setBlogs] = useState([]);

//   useEffect(() => {
//     fetch("http://localhost:5000/api/blog/bloglist")
//       .then((res) => res.json())
//       .then((data) => setBlogs(data.blogs))
//       .catch((err) => console.error("Error fetching blogs:", err));
//   }, []);

//   return (
//     <div className="blog-container">
//       <h1 className="blog-heading">Latest Blogs</h1>
//       <div className="blog-grid">
//         {blogs.length > 0 ? (
//           blogs.map((blog) => (
//             <Link
//               key={blog._id}
//               to={`/blogs/${blog.slug}`}  // ✅ proper redirect
//               className="blog-card"
//             >
//               <img
//                 src={blog.thumbnail?.url}
//                 alt={blog.title}
//                 className="blog-thumbnail"
//               />
//               <div className="blog-content">
//                 <h2 className="blog-title">{blog.title}</h2>
//                 <p className="blog-meta">
//                   By {blog.author} • {new Date(blog.createdAt).toLocaleDateString()}
//                 </p>
//                 <div className="blog-tags">
//                   {blog.tags.map((tag, i) => (
//                     <span key={i} className="blog-tag">
//                       {tag}
//                     </span>
//                   ))}
//                 </div>
//                 {/* ✅ Reduced text snippet */}
//                 <p className="blog-snippet">
//                   {blog.metaDescription
//                     ? blog.metaDescription.substring(0, 70) + "..."
//                     : "Read more..."}
//                 </p>
//               </div>
//             </Link>
//           ))
//         ) : (
//           <p>No blogs found</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default BlogHome;


// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import "./blog.css";

// const BlogHome = () => {
//   const [blogs, setBlogs] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetch("http://localhost:5000/api/blog/bloglist")
//       .then((res) => res.json())
//       .then((data) => {
//         // ✅ Filter only published blogs
//         const publishedBlogs = data.blogs.filter(
//           (blog) => blog.status === "published"
//         );
//         setBlogs(publishedBlogs);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching blogs:", err);
//         setLoading(false);
//       });
//   }, []);

//   if (loading) {
//     return (
//       <div className="blog-container">
//         <div className="skeleton featured-skeleton"></div>
//         <div className="blog-grid">
//           {Array(4)
//             .fill("")
//             .map((_, i) => (
//               <div key={i} className="skeleton card-skeleton"></div>
//             ))}
//         </div>
//       </div>
//     );
//   }

//   if (!blogs.length) return <p>No published blogs found</p>;

//   const latestBlog = blogs[0];
//   const remainingBlogs = blogs.slice(1);

//   return (
//     <div className="blog-container">
//       {/* Featured Blog */}
//       <div className="featured-blog">
//         <img
//           src={latestBlog.thumbnail?.url}
//           alt={latestBlog.title}
//           className="featured-image"
//         />
//         <div className="featured-glass">
//           <span className="featured-tag">{latestBlog.tags[0]}</span>
//           <h2 className="featured-title">{latestBlog.title}</h2>
//           <p className="featured-author">
//             By {latestBlog.author} •{" "}
//             {new Date(latestBlog.createdAt).toLocaleDateString("en-GB", {
//               day: "numeric",
//               month: "long",
//               year: "numeric",
//             })}
//           </p>
//           <Link to={`/blogs/${latestBlog.slug}`} className="featured-link">
//             Read More →
//           </Link>
//         </div>
//       </div>

//       {/* Remaining Blogs */}
//       <h2 className="section-heading">More Articles</h2>
//       <div className="blog-grid">
//         {remainingBlogs.map((blog) => (
//           <Link key={blog._id} to={`/blogs/${blog.slug}`} className="blog-card">
//             <img
//               src={blog.thumbnail?.url}
//               alt={blog.title}
//               className="blog-thumbnail"
//             />
//             <div className="blog-content">
//               <span className="blog-tag">{blog.tags[0]}</span>
//               <h3 className="blog-title">{blog.title}</h3>
//               <p className="blog-meta">
//                 {blog.author} •{" "}
//                 {new Date(blog.createdAt).toLocaleDateString("en-GB", {
//                   day: "numeric",
//                   month: "long",
//                   year: "numeric",
//                 })}
//               </p>
//             </div>
//           </Link>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default BlogHome;







// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import "./blogHome.css";

// const BlogHome = () => {
//   const [blogs, setBlogs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Reading time calculator with null check
//   const getReadingTime = (content) => {
//     if (!content || typeof content !== 'string') return 1;
//     const wordsPerMinute = 200;
//     const words = content.replace(/<[^>]*>/g, '').split(' ').length;
//     return Math.ceil(words / wordsPerMinute);
//   };

//   // Format date
//   const formatDate = (dateStr) => {
//     const options = { day: "numeric", month: "long", year: "numeric" };
//     return new Date(dateStr).toLocaleDateString("en-GB", options);
//   };

//   useEffect(() => {
//     fetch("http://localhost:5000/api/blog/bloglist")
//       .then((res) => {
//         if (!res.ok) throw new Error('Failed to fetch blogs');
//         return res.json();
//       })
//       .then((data) => {
//         // ✅ Filter only published blogs
//         const publishedBlogs = data.blogs.filter(
//           (blog) => blog.status === "published"
//         );
//         setBlogs(publishedBlogs);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching blogs:", err);
//         setError(err.message);
//         setLoading(false);
//       });
//   }, []);

//   // Loading Component
//   const LoadingComponent = () => (
//     <div className="blog-home-container">
//       {/* Hero Section Skeleton */}
//       <div className="hero-section">
//         <div className="hero-content">
//           <div className="skeleton-text skeleton-title"></div>
//           <div className="skeleton-text skeleton-subtitle"></div>
//         </div>
//       </div>

//       {/* Featured Blog Skeleton */}
//       <div className="featured-section">
//         <div className="skeleton-text skeleton-heading"></div>
//         <div className="featured-blog-skeleton">
//           <div className="skeleton-image"></div>
//           <div className="skeleton-content">
//             <div className="skeleton-text skeleton-tag"></div>
//             <div className="skeleton-text skeleton-title"></div>
//             <div className="skeleton-text skeleton-meta"></div>
//           </div>
//         </div>
//       </div>

//       {/* Blog Grid Skeleton */}
//       <div className="blog-grid-section">
//         <div className="skeleton-text skeleton-heading"></div>
//         <div className="blog-grid">
//           {Array(6).fill("").map((_, i) => (
//             <div key={i} className="blog-card-skeleton">
//               <div className="skeleton-image"></div>
//               <div className="skeleton-content">
//                 <div className="skeleton-text skeleton-tag"></div>
//                 <div className="skeleton-text skeleton-title"></div>
//                 <div className="skeleton-text skeleton-meta"></div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );

//   // Error Component
//   const ErrorComponent = () => (
//     <div className="error-state">
//       <div className="error-content">
//         <i className="fas fa-exclamation-triangle"></i>
//         <h2>Something went wrong</h2>
//         <p>{error}</p>
//         <button onClick={() => window.location.reload()} className="retry-button">
//           <i className="fas fa-redo"></i>
//           Try Again
//         </button>
//       </div>
//     </div>
//   );

//   // Empty State Component
//   const EmptyState = () => (
//     <div className="empty-state">
//       <div className="empty-content">
//         <i className="fas fa-file-alt"></i>
//         <h2>No blogs found</h2>
//         <p>There are no published blogs available at the moment.</p>
//       </div>
//     </div>
//   );

//   if (loading) return <LoadingComponent />;
//   if (error) return <ErrorComponent />;
//   if (!blogs.length) return <EmptyState />;

//   const latestBlog = blogs[0];
//   const remainingBlogs = blogs.slice(1);

//   return (
//     <div className={styles.blogHomeContainer}>
//       {/* Hero Section */}
//       <div className={styles.heroSection}>
//         <div className={styles.heroContent}>
//           <h1 className={styles.heroTitle}>
//             Welcome to Our <span className={styles.highlight}>Blog</span>
//           </h1>
//           <p className={styles.heroSubtitle}>
//             Discover insights, tutorials, and stories from our community
//           </p>
//           <div className={styles.heroStats}>
//             <div className={styles.stat}>
//               <i className="fas fa-newspaper"></i>
//               <span>{blogs.length} Articles</span>
//             </div>
//             <div className={styles.stat}>
//               <i className="fas fa-users"></i>
//               <span>Expert Authors</span>
//             </div>
//             <div className={styles.stat}>
//               <i className="fas fa-clock"></i>
//               <span>Fresh Content</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Featured Blog */}
//       <div className={styles.featuredSection}>
//         <h2 className={styles.sectionTitle}>
//           <i className="fas fa-star"></i>
//           Featured Article
//         </h2>
//         <div className={styles.featuredBlog}>
//           <div className={styles.featuredImageContainer}>
//             <img
//               src={latestBlog.thumbnail?.url}
//               alt={latestBlog.title}
//               className={styles.featuredImage}
//               onError={(e) => {
//                 e.target.style.display = 'none';
//                 e.target.nextSibling.style.display = 'flex';
//               }}
//             />
//             <div className={styles.imagePlaceholder} style={{display: 'none'}}>
//               <i className="fas fa-image"></i>
//             </div>
//             <div className={styles.featuredOverlay}>
//               <span className={styles.featuredBadge}>Latest</span>
//             </div>
//           </div>
//           <div className={styles.featuredContent}>
//             <div className={styles.featuredMeta}>
//               <span className={styles.featuredTag}>#{latestBlog.tags?.[0] || 'Blog'}</span>
//               <span className={styles.readingTime}>
//                 <i className="fas fa-clock"></i>
//                 {getReadingTime(latestBlog.contentHtml)} min read
//               </span>
//             </div>
//             <h3 className={styles.featuredTitle}>{latestBlog.title}</h3>
//             <p className={styles.featuredExcerpt}>
//               {latestBlog.metaDescription || 
//                (latestBlog.contentHtml ? 
//                 latestBlog.contentHtml.replace(/<[^>]*>/g, '').substring(0, 150) + '...' : 
//                 'Click to read more about this article...')}
//             </p>
//             <div className={styles.featuredAuthor}>
//               <div className={styles.authorInfo}>
//                 <i className="fas fa-user-circle"></i>
//                 <span>By {latestBlog.author}</span>
//               </div>
//               <div className={styles.publishDate}>
//                 <i className="fas fa-calendar"></i>
//                 <span>{formatDate(latestBlog.createdAt)}</span>
//               </div>
//             </div>
//             <Link to={`/blogs/${latestBlog.slug}`} className={styles.featuredButton}>
//               <span>Read Full Article</span>
//               <i className="fas fa-arrow-right"></i>
//             </Link>
//           </div>
//         </div>
//       </div>

//       {/* All Articles */}
//       <div className={styles.blogGridSection}>
//         <div className={styles.sectionHeader}>
//           <h2 className={styles.sectionTitle}>
//             <i className="fas fa-th-large"></i>
//             All Articles
//           </h2>
//           <p className={styles.sectionSubtitle}>
//             Explore our collection of {remainingBlogs.length} more articles
//           </p>
//         </div>
        
//         <div className={styles.blogGrid}>
//           {remainingBlogs.map((blog) => (
//             <Link key={blog._id} to={`/blogs/${blog.slug}`} className={styles.blogCard}>
//               <div className={styles.blogImageContainer}>
//                 <img
//                   src={blog.thumbnail?.url}
//                   alt={blog.title}
//                   className={styles.blogImage}
//                   onError={(e) => {
//                     e.target.style.display = 'none';
//                     e.target.nextSibling.style.display = 'flex';
//                   }}
//                 />
//                 <div className={styles.blogImagePlaceholder} style={{display: 'none'}}>
//                   <i className="fas fa-image"></i>
//                 </div>
//                 <div className={styles.blogOverlay}>
//                   <span className={styles.blogTag}>#{blog.tags?.[0] || 'Blog'}</span>
//                 </div>
//               </div>
//               <div className={styles.blogCardContent}>
//                 <h4 className={styles.blogCardTitle}>{blog.title}</h4>
//                 <p className={styles.blogCardExcerpt}>
//                   {blog.metaDescription || 
//                    (blog.contentHtml ? 
//                     blog.contentHtml.replace(/<[^>]*>/g, '').substring(0, 100) + '...' : 
//                     'Click to read more...')}
//                 </p>
//                 <div className={styles.blogCardMeta}>
//                   <div className={styles.authorDate}>
//                     <i className="fas fa-user"></i>
//                     <span>{blog.author}</span>
//                     <span className={styles.separator}>•</span>
//                     <i className="fas fa-calendar"></i>
//                     <span>{formatDate(blog.createdAt)}</span>
//                   </div>
//                   <div className={styles.readTime}>
//                     <i className="fas fa-clock"></i>
//                     <span>{getReadingTime(blog.contentHtml)} min</span>
//                   </div>
//                 </div>
//               </div>
//             </Link>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BlogHome;



// -----------------------------------------------working latest with hero banner -----------------------------------


// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import "./blogHome.css";

// const BlogHome = () => {
//   const [blogs, setBlogs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Reading time calculator with null check
//   const getReadingTime = (content) => {
//     if (!content || typeof content !== 'string') return 1;
//     const wordsPerMinute = 200;
//     const words = content.replace(/<[^>]*>/g, '').split(' ').length;
//     return Math.ceil(words / wordsPerMinute);
//   };

//   // Format date
//   const formatDate = (dateStr) => {
//     const options = { day: "numeric", month: "long", year: "numeric" };
//     return new Date(dateStr).toLocaleDateString("en-GB", options);
//   };

//   useEffect(() => {
//     fetch("http://localhost:5000/api/blog/bloglist")
//       .then((res) => {
//         if (!res.ok) throw new Error('Failed to fetch blogs');
//         return res.json();
//       })
//       .then((data) => {
//         // ✅ Filter only published blogs
//         const publishedBlogs = data.blogs.filter(
//           (blog) => blog.status === "published"
//         );
//         setBlogs(publishedBlogs);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching blogs:", err);
//         setError(err.message);
//         setLoading(false);
//       });
//   }, []);

//   // Loading Component
//   const LoadingComponent = () => (
//     <div className="blog-home-wrapper">
//       {/* Hero Section Skeleton */}
//       <div className="blog-hero-section">
//         <div className="blog-hero-content">
//           <div className="blog-skeleton-text blog-skeleton-title"></div>
//           <div className="blog-skeleton-text blog-skeleton-subtitle"></div>
//         </div>
//       </div>

//       {/* Featured Blog Skeleton */}
//       <div className="blog-featured-section">
//         <div className="blog-skeleton-text blog-skeleton-heading"></div>
//         <div className="blog-featured-blog-skeleton">
//           <div className="blog-skeleton-image"></div>
//           <div className="blog-skeleton-content">
//             <div className="blog-skeleton-text blog-skeleton-tag"></div>
//             <div className="blog-skeleton-text blog-skeleton-title"></div>
//             <div className="blog-skeleton-text blog-skeleton-meta"></div>
//           </div>
//         </div>
//       </div>

//       {/* Blog Grid Skeleton */}
//       <div className="blog-grid-section">
//         <div className="blog-skeleton-text blog-skeleton-heading"></div>
//         <div className="blog-grid">
//           {Array(6).fill("").map((_, i) => (
//             <div key={i} className="blog-card-skeleton">
//               <div className="blog-skeleton-image"></div>
//               <div className="blog-skeleton-content">
//                 <div className="blog-skeleton-text blog-skeleton-tag"></div>
//                 <div className="blog-skeleton-text blog-skeleton-title"></div>
//                 <div className="blog-skeleton-text blog-skeleton-meta"></div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );

//   // Error Component
//   const ErrorComponent = () => (
//     <div className="blog-home-wrapper">
//       <div className="blog-error-state">
//         <div className="blog-error-content">
//           <i className="fas fa-exclamation-triangle"></i>
//           <h2>Something went wrong</h2>
//           <p>{error}</p>
//           <button onClick={() => window.location.reload()} className="blog-retry-button">
//             <i className="fas fa-redo"></i>
//             Try Again
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   // Empty State Component
//   const EmptyState = () => (
//     <div className="blog-home-wrapper">
//       <div className="blog-empty-state">
//         <div className="blog-empty-content">
//           <i className="fas fa-file-alt"></i>
//           <h2>No blogs found</h2>
//           <p>There are no published blogs available at the moment.</p>
//         </div>
//       </div>
//     </div>
//   );

//   if (loading) return <LoadingComponent />;
//   if (error) return <ErrorComponent />;
//   if (!blogs.length) return <EmptyState />;

//   const latestBlog = blogs[0];
//   const remainingBlogs = blogs.slice(1);

//   return (
//     <div className="blog-home-wrapper">
//       {/* Hero Section */}
//       <div className="blog-hero-section">
//         <div className="blog-hero-content">
//           <h1 className="blog-hero-title">
//             Welcome to Our <span className="blog-highlight">Blog</span>
//           </h1>
//           <p className="blog-hero-subtitle">
//             Discover insights, tutorials, and stories from our community
//           </p>
//           <div className="blog-hero-stats">
//             <div className="blog-stat">
//               <i className="fas fa-newspaper"></i>
//               <span>{blogs.length} Articles</span>
//             </div>
//             <div className="blog-stat">
//               <i className="fas fa-users"></i>
//               <span>Expert Authors</span>
//             </div>
//             <div className="blog-stat">
//               <i className="fas fa-clock"></i>
//               <span>Fresh Content</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Featured Blog */}
//       <div className="blog-featured-section">
//         <h2 className="blog-section-title">
//           <i className="fas fa-star"></i>
//           Featured Article
//         </h2>
//         <div className="blog-featured-blog">
//           <div className="blog-featured-image-container">
//             <img
//               src={latestBlog.thumbnail?.url}
//               alt={latestBlog.title}
//               className="blog-featured-image"
//               onError={(e) => {
//                 e.target.style.display = 'none';
//                 e.target.nextSibling.style.display = 'flex';
//               }}
//             />
//             <div className="blog-image-placeholder" style={{display: 'none'}}>
//               <i className="fas fa-image"></i>
//             </div>
//             <div className="blog-featured-overlay">
//               <span className="blog-featured-badge">Latest</span>
//             </div>
//           </div>
//           <div className="blog-featured-content">
//             <div className="blog-featured-meta">
//               <span className="blog-featured-tag">#{latestBlog.tags?.[0] || 'Blog'}</span>
//               <span className="blog-reading-time">
//                 <i className="fas fa-clock"></i>
//                 {getReadingTime(latestBlog.contentHtml)} min read
//               </span>
//             </div>
//             <h3 className="blog-featured-title">{latestBlog.title}</h3>
//             <p className="blog-featured-excerpt">
//               {latestBlog.metaDescription || 
//                (latestBlog.contentHtml ? 
//                 latestBlog.contentHtml.replace(/<[^>]*>/g, '').substring(0, 150) + '...' : 
//                 'Click to read more about this article...')}
//             </p>
//             <div className="blog-featured-author">
//               <div className="blog-author-info">
//                 <i className="fas fa-user-circle"></i>
//                 <span>By {latestBlog.author}</span>
//               </div>
//               <div className="blog-publish-date">
//                 <i className="fas fa-calendar"></i>
//                 <span>{formatDate(latestBlog.createdAt)}</span>
//               </div>
//             </div>
//             <Link to={`/blogs/${latestBlog.slug}`} className="blog-featured-button">
//               <span>Read Full Article</span>
//               <i className="fas fa-arrow-right"></i>
//             </Link>
//           </div>
//         </div>
//       </div>

//       {/* All Articles */}
//       <div className="blog-grid-section">
//         <div className="blog-section-header">
//           <h2 className="blog-section-title">
//             <i className="fas fa-th-large"></i>
//             All Articles
//           </h2>
//           <p className="blog-section-subtitle">
//             Explore our collection of {remainingBlogs.length} more articles
//           </p>
//         </div>
        
//         <div className="blog-grid">
//           {remainingBlogs.map((blog) => (
//             <Link key={blog._id} to={`/blogs/${blog.slug}`} className="blog-card">
//               <div className="blog-image-container">
//                 <img
//                   src={blog.thumbnail?.url}
//                   alt={blog.title}
//                   className="blog-image"
//                   onError={(e) => {
//                     e.target.style.display = 'none';
//                     e.target.nextSibling.style.display = 'flex';
//                   }}
//                 />
//                 <div className="blog-image-placeholder" style={{display: 'none'}}>
//                   <i className="fas fa-image"></i>
//                 </div>
//                 <div className="blog-overlay">
//                   <span className="blog-tag">#{blog.tags?.[0] || 'Blog'}</span>
//                 </div>
//               </div>
//               <div className="blog-card-content">
//                 <h4 className="blog-card-title">{blog.title}</h4>
//                 <p className="blog-card-excerpt">
//                   {blog.metaDescription || 
//                    (blog.contentHtml ? 
//                     blog.contentHtml.replace(/<[^>]*>/g, '').substring(0, 100) + '...' : 
//                     'Click to read more...')}
//                 </p>
//                 <div className="blog-card-meta">
//                   <div className="blog-author-date">
//                     <i className="fas fa-user"></i>
//                     <span>{blog.author}</span>
//                     <span className="blog-separator">•</span>
//                     <i className="fas fa-calendar"></i>
//                     <span>{formatDate(blog.createdAt)}</span>
//                   </div>
//                   <div className="blog-read-time">
//                     <i className="fas fa-clock"></i>
//                     <span>{getReadingTime(blog.contentHtml)} min</span>
//                   </div>
//                 </div>
//               </div>
//             </Link>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BlogHome;





import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./blogHome.css";

const BlogHome = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Reading time calculator with null check
  const getReadingTime = (content) => {
    if (!content || typeof content !== 'string') return 1;
    const wordsPerMinute = 200;
    const words = content.replace(/<[^>]*>/g, '').split(' ').length;
    return Math.ceil(words / wordsPerMinute);
  };

  // Format date
  const formatDate = (dateStr) => {
    const options = { day: "numeric", month: "long", year: "numeric" };
    return new Date(dateStr).toLocaleDateString("en-GB", options);
  };

  useEffect(() => {
    // fetch("http://localhost:5000/api/blog/bloglist")
    const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
    fetch(`${API_URL}/blog/bloglist`)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch blogs');
        return res.json();
      })
      .then((data) => {
        // ✅ Filter only published blogs
        const publishedBlogs = data.blogs.filter(
          (blog) => blog.status === "published"
        );
        setBlogs(publishedBlogs);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching blogs:", err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  // Loading Component
  const LoadingComponent = () => (
    <div className="blog-home-wrapper">
      {/* Page Header Skeleton */}
      <div className="blog-page-header">
        <div className="blog-skeleton-text blog-skeleton-title"></div>
        <div className="blog-skeleton-text blog-skeleton-subtitle"></div>
      </div>

      {/* Featured Blog Skeleton */}
      <div className="blog-featured-section">
        <div className="blog-skeleton-text blog-skeleton-heading"></div>
        <div className="blog-featured-blog-skeleton">
          <div className="blog-skeleton-image"></div>
          <div className="blog-skeleton-content">
            <div className="blog-skeleton-text blog-skeleton-tag"></div>
            <div className="blog-skeleton-text blog-skeleton-title"></div>
            <div className="blog-skeleton-text blog-skeleton-meta"></div>
          </div>
        </div>
      </div>

      {/* Blog Grid Skeleton */}
      <div className="blog-grid-section">
        <div className="blog-skeleton-text blog-skeleton-heading"></div>
        <div className="blog-grid">
          {Array(6).fill("").map((_, i) => (
            <div key={i} className="blog-card-skeleton">
              <div className="blog-skeleton-image"></div>
              <div className="blog-skeleton-content">
                <div className="blog-skeleton-text blog-skeleton-tag"></div>
                <div className="blog-skeleton-text blog-skeleton-title"></div>
                <div className="blog-skeleton-text blog-skeleton-meta"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  // Error Component
  const ErrorComponent = () => (
    <div className="blog-home-wrapper">
      <div className="blog-error-state">
        <div className="blog-error-content">
          <i className="fas fa-exclamation-triangle"></i>
          <h2>Something went wrong</h2>
          <p>{error}</p>
          <button onClick={() => window.location.reload()} className="blog-retry-button">
            <i className="fas fa-redo"></i>
            Try Again
          </button>
        </div>
      </div>
    </div>
  );

  // Empty State Component
  const EmptyState = () => (
    <div className="blog-home-wrapper">
      <div className="blog-empty-state">
        <div className="blog-empty-content">
          <i className="fas fa-file-alt"></i>
          <h2>No blogs found</h2>
          <p>There are no published blogs available at the moment.</p>
        </div>
      </div>
    </div>
  );

  if (loading) return <LoadingComponent />;
  if (error) return <ErrorComponent />;
  if (!blogs.length) return <EmptyState />;

  const latestBlog = blogs[0];
  const remainingBlogs = blogs.slice(1);
  
  // Filter student blogs
  const studentBlogs = blogs.filter(blog => 
    blog.tags && blog.tags.some(tag => 
      tag.toLowerCase().includes('student')
    )
  );

  return (
    <div className="blog-home-wrapper">
      {/* Page Header */}
      <div className="blog-page-header">
        <h1 className="blog-page-title">
          Welcome to Our <span className="blog-highlight">Blog</span>
        </h1>
        {/* <p className="blog-page-subtitle">
          Discover insights, tutorials, and stories from our community
        </p> */}
      </div>

      {/* Featured Blog */}
      <div className="blog-featured-section">
        <h2 className="blog-section-title">
          <i className="fas fa-star"></i>
          Featured Article
        </h2>
        <div className="blog-featured-blog">
          <div className="blog-featured-image-container">
            <img
              src={latestBlog.thumbnail?.url}
              alt={latestBlog.title}
              className="blog-featured-image"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className="blog-image-placeholder" style={{display: 'none'}}>
              <i className="fas fa-image"></i>
            </div>
            <div className="blog-featured-overlay">
              <span className="blog-featured-badge">Latest</span>
            </div>
          </div>
          <div className="blog-featured-content">
            <div className="blog-featured-meta">
              <span className="blog-featured-tag">#{latestBlog.tags?.[0] || 'Blog'}</span>
              <span className="blog-reading-time">
                <i className="fas fa-clock"></i>
                {getReadingTime(latestBlog.contentHtml)} min read
              </span>
            </div>
            <h3 className="blog-featured-title">{latestBlog.title}</h3>
            <p className="blog-featured-excerpt">
              {latestBlog.metaDescription || 
               (latestBlog.contentHtml ? 
                latestBlog.contentHtml.replace(/<[^>]*>/g, '').substring(0, 150) + '...' : 
                'Click to read more about this article...')}
            </p>
            <div className="blog-featured-author">
              <div className="blog-author-info">
                <i className="fas fa-user-circle"></i>
                <span>By {latestBlog.author}</span>
              </div>
              <div className="blog-publish-date">
                <i className="fas fa-calendar"></i>
                <span>{formatDate(latestBlog.createdAt)}</span>
              </div>
            </div>
            <Link to={`/blogs/${latestBlog.slug}`} className="blog-featured-button">
              <span>Read Full Article</span>
              <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>

      {/* Student Blogs Section */}
      {studentBlogs.length > 0 && (
        <div className="blog-grid-section">
          <div className="blog-section-header">
            <h2 className="blog-section-title">
              <i className="fas fa-graduation-cap"></i>
              Student Stories
            </h2>
            <p className="blog-section-subtitle">
              Insights and experiences from our student community
            </p>
          </div>
          
          <div className="blog-grid">
            {studentBlogs.slice(0, 6).map((blog) => (
              <Link key={blog._id} to={`/blogs/${blog.slug}`} className="blog-card">
                <div className="blog-image-container">
                  <img
                    src={blog.thumbnail?.url}
                    alt={blog.title}
                    className="blog-image"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="blog-image-placeholder" style={{display: 'none'}}>
                    <i className="fas fa-image"></i>
                  </div>
                  <div className="blog-overlay">
                    <span className="blog-tag">#{blog.tags?.[0] || 'Student'}</span>
                  </div>
                </div>
                <div className="blog-card-content">
                  <h4 className="blog-card-title">{blog.title}</h4>
                  <p className="blog-card-excerpt">
                    {blog.metaDescription || 
                     (blog.contentHtml ? 
                      blog.contentHtml.replace(/<[^>]*>/g, '').substring(0, 100) + '...' : 
                      'Click to read more...')}
                  </p>
                  <div className="blog-card-meta">
                    <div className="blog-author-date">
                      <i className="fas fa-user"></i>
                      <span>{blog.author}</span>
                      <span className="blog-separator">•</span>
                      <i className="fas fa-calendar"></i>
                      <span>{formatDate(blog.createdAt)}</span>
                    </div>
                    <div className="blog-read-time">
                      <i className="fas fa-clock"></i>
                      <span>{getReadingTime(blog.contentHtml)} min</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}

      {/* All Articles */}
      <div className="blog-grid-section">
        <div className="blog-section-header">
          <h2 className="blog-section-title">
            <i className="fas fa-th-large"></i>
            All Articles
          </h2>
          <p className="blog-section-subtitle">
            Explore our collection of articles
          </p>
        </div>
        
        <div className="blog-grid">
          {remainingBlogs.map((blog) => (
            <Link key={blog._id} to={`/blogs/${blog.slug}`} className="blog-card">
              <div className="blog-image-container">
                <img
                  src={blog.thumbnail?.url}
                  alt={blog.title}
                  className="blog-image"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="blog-image-placeholder" style={{display: 'none'}}>
                  <i className="fas fa-image"></i>
                </div>
                <div className="blog-overlay">
                  <span className="blog-tag">#{blog.tags?.[0] || 'Blog'}</span>
                </div>
              </div>
              <div className="blog-card-content">
                <h4 className="blog-card-title">{blog.title}</h4>
                <p className="blog-card-excerpt">
                  {blog.metaDescription || 
                   (blog.contentHtml ? 
                    blog.contentHtml.replace(/<[^>]*>/g, '').substring(0, 100) + '...' : 
                    'Click to read more...')}
                </p>
                <div className="blog-card-meta">
                  <div className="blog-author-date">
                    <i className="fas fa-user"></i>
                    <span>{blog.author}</span>
                    <span className="blog-separator">•</span>
                    <i className="fas fa-calendar"></i>
                    <span>{formatDate(blog.createdAt)}</span>
                  </div>
                  <div className="blog-read-time">
                    <i className="fas fa-clock"></i>
                    <span>{getReadingTime(blog.contentHtml)} min</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogHome;